import { render, staticRenderFns } from "./UserInferenceHelp.vue?vue&type=template&id=2916183e&"
import script from "./UserInferenceHelp.vue?vue&type=script&lang=js&"
export * from "./UserInferenceHelp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports